module.exports = __webpack_public_path__ + "static/media/vector5.a59e3300.webp";